import type { AdminViewDefinition } from "../../components/admin-components.js";
import { installationDirectoryAdminViews } from "./directory/installation-directory-pages.js";
import { installationStateAdminViews } from "./states/installation-state-pages.js";
import { storeDetailAdminViews } from "./store-detail/store-detail-pages.js";
import { supportAdminViews } from "./support/support-pages.js";

export const installationAdminViews: AdminViewDefinition[] = [
  ...installationDirectoryAdminViews,
  ...storeDetailAdminViews,
  ...installationStateAdminViews,
  ...supportAdminViews,
];
